module.exports = __webpack_public_path__ + "static/scale-model-of-book-of-mormon-tours-in-provo-utah-c38a6aefbbeee835015a3bcb7bebae0d.png";